/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import UblockIcon from "../Icon/unlock.svg";
import ShowPassword from "../Icon/eye.svg";
import HidePassword from "../Icon/eye-slash.svg";
import DatePicker from "react-datepicker";
import { IoMdClose } from "react-icons/io";
import { MdChevronLeft, MdChevronRight, MdDateRange, MdMyLocation } from "react-icons/md";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { showTost } from "../showTost";
import PageHeader from "./PageHeader";
import { FiUser, FiCamera, FiLock, FiPhone, FiMail, FiMapPin, FiHeart, FiGlobe, FiSmile } from "react-icons/fi";
import { fetchProfileCompletion, getProfileCompletion, syncRegisterUser } from "../utils/profileCompletion";
import {
  defaultGenderOptions,
  defaultSearchPreferenceOptions,
  fetchGenderOptions,
} from "../utils/genderOptions";
import {
  defaultDistanceSettings,
  fetchDistanceSettings,
} from "../utils/distanceSettings";
import {
  defaultAgeSettings,
  fetchAgeSettings,
} from "../utils/ageSettings";

const Profile = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const { imageBaseURL, basUrl, setUpdateId, updateId } = useContext(MyContext);

  const [imagearray, setImagearray] = useState([]);
  const [nickName, setNickName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNummber] = useState("");
  const [ccode, setCcode] = useState("");
  const [Password, setpassword] = useState("");
  const [distance, setDistance] = useState(defaultDistanceSettings.defaultDistance);
  const [distanceSettings, setDistanceSettings] = useState(defaultDistanceSettings);
  const [ageSettings, setAgeSettings] = useState(defaultAgeSettings);
  const [birthdate, setBirthDate] = useState("");
  const [bio, setBio] = useState("");
  const [gender, setGender] = useState("");
  const [interest, setInterest] = useState([]);
  const [language, setLanguage] = useState([]);
  const [religion, setReligion] = useState("");
  const [preference, setPreference] = useState("");
  const [relationship, setRelationship] = useState("");
  const [uid, setUid] = useState();
  const [height, setHeight] = useState();
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [locationStatus, setLocationStatus] = useState("");
  const [locationAddress, setLocationAddress] = useState("");

  const isValidCoordinate = (value) => {
    if (value === undefined || value === null) return false;
    const text = String(value).trim();
    if (!text || text === "undefined" || text === "null") return false;
    const number = Number(text);
    return Number.isFinite(number) && number !== 0;
  };
  const [images, setImages] = useState([null]);
  const [interestList, setInterestList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [relationshipList, setRelationshipList] = useState([]);
  const [profileCompletion, setProfileCompletion] = useState(getProfileCompletion());
  const [genderOptions, setGenderOptions] = useState(defaultGenderOptions);
  const [searchPreferenceOptions, setSearchPreferenceOptions] = useState(defaultSearchPreferenceOptions);

  const InputRef = useRef([]);
  const bioRef = useRef(null);
  const locationRef = useRef(null);

  const maxBirthDate = new Date();
  maxBirthDate.setFullYear(maxBirthDate.getFullYear() - ageSettings.minAge);
  const minBirthDate = new Date();
  minBirthDate.setFullYear(minBirthDate.getFullYear() - ageSettings.maxAge);
  const parseBirthDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return null;
    const str = dateStr.trim();
    if (!str || str === "0000-00-00") return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      const [y, m, d] = str.split("-").map(Number);
      const date = new Date(y, m - 1, d);
      return !isNaN(date.getTime()) ? date : null;
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(str)) {
      const [d, m, y] = str.split("-").map(Number);
      const date = new Date(y, m - 1, d);
      return !isNaN(date.getTime()) ? date : null;
    }

    const parsed = new Date(str);
    return !isNaN(parsed.getTime()) ? parsed : null;
  };

  const selectedBirthDate = parseBirthDate(birthdate);
  const selectedAge = selectedBirthDate ? (() => {
    const today = new Date();
    let age = today.getFullYear() - selectedBirthDate.getFullYear();
    const monthDiff = today.getMonth() - selectedBirthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < selectedBirthDate.getDate())) {
      age -= 1;
    }
    return age;
  })() : null;

  const formatDateValue = (date) => {
    if (!date || isNaN(date.getTime())) return "";
    try {
      return format(date, "yyyy-MM-dd");
    } catch {
      return "";
    }
  };

  useEffect(() => {
    fetchGenderOptions(basUrl).then(
      ({ personalGenderOptions, searchPreferenceOptions }) => {
        setGenderOptions(personalGenderOptions);
        setSearchPreferenceOptions(searchPreferenceOptions);
      },
    );
    fetchDistanceSettings(basUrl).then((settings) => {
      setDistanceSettings(settings);
      setDistance((current) => {
        const parsed = Number(current);
        if (Number.isFinite(parsed) && parsed > 0) {
          return Math.min(Math.max(parsed, settings.minDistance), settings.maxDistance);
        }
        return settings.defaultDistance;
      });
    });
    fetchAgeSettings(basUrl).then(setAgeSettings);
  }, [basUrl]);

  const percent = ((Number(distance) - distanceSettings.minDistance) / (distanceSettings.maxDistance - distanceSettings.minDistance)) * 100;

  const sliderStyle = {
    background: `linear-gradient(to right, rgba(152,14,255,255) ${percent}%, rgba(199, 197, 197, 0.801) ${percent}%)`,
  };

  const Show = useRef();
  const Hide = useRef();

  const myFunction = () => {
    var x = document.getElementById("input");
    if (x.type === "password") {
      x.type = "text";
      Show.current.style.display = "block";
      Hide.current.style.display = "none";
    } else {
      x.type = "password";
      Hide.current.style.display = "block";
      Show.current.style.display = "none";
    }
  };

  const InterestMapHandler = (id) => {
    const idStr = String(id).trim().toLowerCase();
    const isAlreadySelected = interest.some(
      (item) => String(item).trim().toLowerCase() === idStr
    );
    if (isAlreadySelected) {
      setInterest(
        interest.filter(
          (item) => String(item).trim().toLowerCase() !== idStr
        )
      );
    } else {
      if (interest.length > 4) return;
      setInterest([...interest, id]);
    }
  };

  const LanguageMapHandler = (id) => {
    const idStr = String(id).trim().toLowerCase();
    const isAlreadySelected = language.some(
      (item) => String(item).trim().toLowerCase() === idStr
    );
    if (isAlreadySelected) {
      setLanguage(
        language.filter(
          (item) => String(item).trim().toLowerCase() !== idStr
        )
      );
    } else {
      if (language.length > 4) return;
      setLanguage([...language, id]);
    }
  };

  const applyUserData = useCallback((userObj) => {
    if (!userObj) return;
    setNickName(userObj.name || "");
    setEmail(userObj.email || "");
    setNummber(userObj.mobile || "");
    setCcode(userObj.ccode || "");
    setpassword(userObj.password || "");
    setBirthDate(userObj.birth_date || "");
    setPreference(userObj.search_preference ? String(userObj.search_preference) : "");
    if (userObj.radius_search) {
      setDistance(Number(userObj.radius_search));
    }
    setRelationship(userObj.relation_goal ? String(userObj.relation_goal) : "");
    setBio(userObj.profile_bio || "");
    setGender(userObj.gender ? String(userObj.gender) : "");
    setReligion(userObj.religion ? String(userObj.religion) : "");
    setHeight(userObj.height || "");
    setUid(userObj.id || userObj.uid);

    if (isValidCoordinate(userObj.lats)) setLatitude(userObj.lats);
    if (isValidCoordinate(userObj.longs)) setLongitude(userObj.longs);

    if (userObj.interest) {
      if (Array.isArray(userObj.interest)) {
        setInterest(userObj.interest.map((item) => String(item).trim()).filter(Boolean));
      } else if (typeof userObj.interest === "string") {
        setInterest(userObj.interest.split(",").map((item) => item.trim()).filter(Boolean));
      } else {
        setInterest([]);
      }
    } else {
      setInterest([]);
    }

    if (userObj.language) {
      if (Array.isArray(userObj.language)) {
        setLanguage(userObj.language.map((item) => String(item).trim()).filter(Boolean));
      } else if (typeof userObj.language === "string") {
        setLanguage(userObj.language.split(",").map((item) => item.trim()).filter(Boolean));
      } else {
        setLanguage([]);
      }
    } else {
      setLanguage([]);
    }

    const parsePhotoField = (field) => {
      if (!field) return [];
      if (Array.isArray(field)) {
        return field.map(String).map((p) => p.trim()).filter((p) => p && p !== "0" && p !== "null" && p !== "undefined");
      }
      if (typeof field === "string") {
        const raw = field.trim();
        if (!raw || raw === "0" || raw === "null" || raw === "undefined") return [];
        const delimiter = raw.includes("$;") ? "$;" : raw.includes(",") ? "," : "$;";
        return raw.split(delimiter).map((p) => p.trim()).filter((p) => p && p !== "0" && p !== "null" && p !== "undefined");
      }
      return [];
    };

    const otherPicList = parsePhotoField(userObj.otherpic);
    const imList = parsePhotoField(userObj.imlist);
    const other_picList = parsePhotoField(userObj.other_pic);

    const combined = [...new Set([...otherPicList, ...imList, ...other_picList])];

    const mainPic = userObj.profile_pic || userObj.pro_pic || userObj.user_pic;
    if (mainPic && typeof mainPic === "string" && mainPic.trim() !== "" && mainPic !== "0" && mainPic !== "null") {
      const cleanMain = mainPic.trim();
      if (!combined.includes(cleanMain)) {
        combined.unshift(cleanMain);
      }
    }

    setImagearray(combined);
  }, []);

  const GetUserDetail = useCallback(() => {
    try {
      const registerUser = JSON.parse(localStorage.getItem("Register_User") || "{}");
      const currentUid = registerUser.id || registerUser.uid;
      if (currentUid) {
        applyUserData(registerUser);
        fetchProfileCompletion(basUrl, currentUid).then((completion) => {
          if (completion) setProfileCompletion(completion);
        }).catch(() => {});
        axios.post(`${basUrl}profile_detail`, { uid: currentUid }).then((res) => {
          if (res.data.Result === "true" && res.data.UserLogin) {
            const token = registerUser.token || localStorage.getItem("token") || "";
            const updatedUser = { ...registerUser, ...res.data.UserLogin, token };
            localStorage.setItem("Register_User", JSON.stringify(updatedUser));
            applyUserData(updatedUser);
          }
        }).catch(() => {});
      }
    } catch (e) {
      console.error("Error reading Register_User:", e);
    }
  }, [applyUserData, basUrl]);

  useEffect(() => {
    GetUserDetail();
  }, [GetUserDetail]);

  const requestCurrentLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setLocationStatus("Geolocation is not supported by your browser.");
      return;
    }

    setLocationStatus(t("Locating..."));
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        setLatitude(lat);
        setLongitude(lng);

        localStorage.setItem("user_latitude", String(lat));
        localStorage.setItem("user_longitude", String(lng));

        const uidValue = getUserId();
        if (uidValue && basUrl) {
          axios
            .post(`${basUrl}edit_profile`, {
              uid: uidValue,
              lats: lat,
              longs: lng,
            })
            .catch(() => {});
        }

        axios
          .get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`)
          .then((res) => {
            const address = res.data?.display_name;
            if (address) {
              setLocationAddress(address);
              setLocationStatus(t("Location updated successfully."));
            } else {
              setLocationStatus(t("Coordinates updated."));
            }
          })
          .catch(() => {
            setLocationStatus(t("Coordinates updated."));
          });
      },
      (error) => {
        console.warn("Location fetch error:", error);
        setLocationStatus(
          error.code === error.PERMISSION_DENIED
            ? t("Location permission denied. Please allow browser location access.")
            : t("Unable to fetch location right now."),
        );
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  }, [basUrl, t]);

  useEffect(() => {
    if (location.state?.focusBio) {
      bioRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      bioRef.current?.focus();
    }
    if (location.state?.requireLocation || location.state?.profileCompletionRequired) {
      if (!isValidCoordinate(latitude) || !isValidCoordinate(longitude)) {
        requestCurrentLocation();
      }
    }
  }, [location.state, latitude, longitude, requestCurrentLocation]);

  const completionPercent = Math.max(
    0,
    Math.min(
      100,
      Number(profileCompletion?.completion_percent ?? localStorage.getItem("Profile_ratio") ?? 0),
    ),
  );
  const isLocationMissing = !isValidCoordinate(latitude) || !isValidCoordinate(longitude);
  const missingCompletionTasks = profileCompletion?.missing_tasks || [];
  const shouldShowCompletionNudge = completionPercent < 100 || isLocationMissing;

  const GetHandler = useCallback(() => {
    axios.post(`${basUrl}interest`).then((res) => {
      setInterestList(res.data.interestlist || []);
    }).catch(() => {});
    axios.post(`${basUrl}languagelist`).then((res) => {
      setLanguageList(res.data.languagelist || []);
    }).catch(() => {});
    axios.post(`${basUrl}religionlist`).then((res) => {
      setReligionList(res.data.religionlist || []);
    }).catch(() => {});
    axios.post(`${basUrl}goal`).then((res) => {
      setRelationshipList(res.data.goallist || []);
    }).catch(() => {});
  }, [basUrl]);

  useEffect(() => {
    GetHandler();
  }, [GetHandler]);

  const CloseHandler = (index) => {
    setImagearray((prev) => prev.filter((_, idx) => idx !== index));
  };

  const getUserId = () => {
    try {
      return JSON.parse(localStorage.getItem("Register_User") || "{}").id;
    } catch {
      return null;
    }
  };

  const handleSubmit = () => {
    const uploadedCount = imagearray.length;
    const newFilesCount = images.filter((img) => img !== null).length;
    const totalImageCount = uploadedCount + newFilesCount;

    if (totalImageCount >= 3) {
      const Validation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

      if (Validation.test(email)) {
        const formData = new FormData();

        formData.append("name", nickName);
        formData.append("mobile", number);
        formData.append("email", email);
        formData.append("ccode", ccode);
        formData.append("birth_date", birthdate);
        formData.append("search_preference", preference);
        formData.append("radius_search", Number(distance).toFixed(2));
        formData.append("relation_goal", relationship);
        formData.append("profile_bio", bio ? bio : undefined);
        formData.append("interest", interest.join(","));
        formData.append("language", language.join(","));
        formData.append("password", Password);
        formData.append("gender", gender);
        if (isValidCoordinate(latitude) && isValidCoordinate(longitude)) {
          formData.append("lats", latitude);
          formData.append("longs", longitude);
        }
        formData.append("religion", religion);
        formData.append("size", images && images.length - 1);
        formData.append("uid", uid);
        formData.append("height", height ? height : undefined);
        formData.append(
          "imlist",
          imagearray.length === 0 ? "0" : imagearray.join("$;"),
        );

        images.forEach((image, index) => {
          if (image) {
            formData.append(`otherpic${index}`, image);
          }
        });

        axios
          .post(`${basUrl}edit_profile`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(async (res) => {
            if (res.data.Result === "true") {
              setUpdateId(updateId + 1);
              const existingUser = JSON.parse(localStorage.getItem("Register_User") || "{}");
              const token = existingUser.token || localStorage.getItem("token") || "";
              const syncedUser = await syncRegisterUser(basUrl, uid).catch(() => null);
              const updatedUser = { ...existingUser, ...res.data.UserLogin, ...(syncedUser || {}), token };
              localStorage.setItem(
                "Register_User",
                JSON.stringify(updatedUser),
              );
              applyUserData(updatedUser);
              fetchProfileCompletion(basUrl, uid).then((completion) => {
                if (completion) setProfileCompletion(completion);
              }).catch(() => {});
              showTost({ title: res.data.ResponseMsg });
            }
          })
          .catch((err) => {
            showTost({ title: err?.response?.data?.ResponseMsg || err.message || "Failed to update profile" });
          });
      } else {
        showTost({ title: "Please enter a valid email address" });
      }
    } else {
      showTost({ title: "Please add a minimum of 3 photos" });
    }
  };

  const handleImageChange = (index, file) => {
    setImages((prev) => {
      const updatedImages = [...prev];
      updatedImages[index] = file;
      return updatedImages;
    });

    if (index === images.length - 1) {
      setImages((prev) => [...prev, null]);
    }
  };

  const handleRemoveImage = (index) => {
    setImages((prev) => prev.filter((_, idx) => idx !== index));
  };

  return (
    <Formik initialValues={{}} onSubmit={handleSubmit}>
      {(props) => (
        <div style={{ userSelect: "none", cursor: "default" }}>
          <div className="main-wrapper-history bg-[#f5f5f7] min-h-screen">
            <div className="content-body">
              <div className="container-fluid my-2 sm:my-4 px-2.5 sm:px-4">
              <PageHeader
                title={t("My Profile")}
                subtitle={t("Manage your photos, personal details, and match preferences")}
                breadcrumbs={[{ label: t("My Profile") }]}
                icon={FiUser}
              />
              <div className="bg-white p-4 sm:p-6 lg:p-8 rounded-2xl shadow-xs border border-gray-200/80 w-full">
                {shouldShowCompletionNudge && (
                  <div className="mb-6 border border-purple-200 bg-purple-50/50 rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 shadow-xs">
                    <div className="w-12 h-12 rounded-2xl bg-purple-100 text-purple-700 flex items-center justify-center text-xl font-bold shrink-0">
                      !
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-2">
                        <div>
                          <h2 className="text-base sm:text-lg font-bold text-gray-900 m-0">{t("Complete your profile")}</h2>
                          <p className="text-xs sm:text-sm text-gray-600 m-0 mt-0.5">
                            {completionPercent}% {t("complete. Add the missing details to unlock all features.")}
                          </p>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            if (isLocationMissing) {
                              requestCurrentLocation();
                              locationRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
                              return;
                            }
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                          className="px-4 py-2 rounded-xl bg-purple-600 hover:bg-purple-700 text-white text-xs font-semibold shadow-xs transition-colors shrink-0 cursor-pointer"
                        >
                          {t("Update")}
                        </button>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {missingCompletionTasks.map((task) => (
                          <button
                            type="button"
                            key={task.task_key}
                            onClick={() => {
                              if (task.field_name === "location" || task.task_key === "location") {
                                requestCurrentLocation();
                                locationRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
                              }
                            }}
                            className="px-3 py-1 rounded-full bg-white border border-purple-200 text-purple-700 text-xs font-medium hover:bg-purple-50 transition-colors cursor-pointer"
                          >
                            {task.title}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <form onSubmit={props.handleSubmit} className="space-y-6 sm:space-y-8">
                  {/* Section 1: Photos */}
                  <div>
                    <div className="flex items-center justify-between mb-3 pb-2 border-b border-gray-100">
                      <h3 className="text-sm sm:text-base font-bold text-gray-900 flex items-center gap-2 m-0">
                        <FiCamera className="text-purple-600 text-base" />
                        {t("Profile Photos")}
                      </h3>
                      <span className="text-xs text-gray-400 font-medium">Min 3 photos required</span>
                    </div>
                    <p className="text-xs sm:text-sm text-gray-500 mb-4">
                      {t("Update your personal photos here.")}
                    </p>

                    <div className="flex flex-wrap gap-3 sm:gap-4">
                      {imagearray.map((item, index) => (
                        <div
                          key={`existing-${index}`}
                          className="relative w-28 sm:w-36 aspect-[3/4] rounded-2xl overflow-hidden border border-gray-200 shadow-xs group bg-gray-100 shrink-0"
                        >
                          {item && (
                            <button
                              type="button"
                              onClick={() => CloseHandler(index)}
                              className="z-10 w-7 h-7 absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center shadow-md transition-transform group-hover:scale-110 cursor-pointer"
                              title="Delete photo"
                            >
                              <IoMdClose className="text-base" />
                            </button>
                          )}
                          <img
                            src={
                              typeof item === "string" && (item.startsWith("http://") || item.startsWith("https://") || item.startsWith("data:"))
                                ? item
                                : `${imageBaseURL}${item}`
                            }
                            className="w-full h-full object-cover"
                            alt="Profile"
                          />
                        </div>
                      ))}
                      {images.map((item, index) => (
                        <div
                          key={`new-${index}`}
                          className="relative w-28 sm:w-36 aspect-[3/4] rounded-2xl overflow-hidden border-2 border-dashed border-purple-200 hover:border-purple-400 bg-purple-50/30 transition-colors flex items-center justify-center cursor-pointer group shrink-0"
                          onClick={() => !item && InputRef.current[index]?.click()}
                        >
                          {item ? (
                            <>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveImage(index);
                                }}
                                className="z-10 w-7 h-7 absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center shadow-md transition-transform group-hover:scale-110 cursor-pointer"
                                title="Remove photo"
                              >
                                <IoMdClose className="text-base" />
                              </button>
                              <img
                                src={URL.createObjectURL(item)}
                                className="w-full h-full object-cover"
                                alt="New Upload"
                              />
                            </>
                          ) : (
                            <div className="flex flex-col items-center justify-center p-2 text-center">
                              <div className="w-10 h-10 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xl mb-1 group-hover:scale-110 transition-transform">
                                +
                              </div>
                              <span className="text-[11px] font-semibold text-purple-700">Add Photo</span>
                            </div>
                          )}

                          <input
                            disabled={Boolean(item)}
                            ref={(el) => (InputRef.current[index] = el)}
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                handleImageChange(index, file);
                              }
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Section 2: Personal Information */}
                  <div>
                    <div className="flex items-center justify-between mb-4 pb-2 border-b border-gray-100">
                      <h3 className="text-sm sm:text-base font-bold text-gray-900 flex items-center gap-2 m-0">
                        <FiUser className="text-purple-600 text-base" />
                        {t("Personal Information")}
                      </h3>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                      {/* Nick Name */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Nick Name")}
                        </label>
                        <input
                          value={nickName}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            if (name === "name") setNickName(value);
                          }}
                          type="text"
                          name="name"
                          className="gomeet-input w-full"
                          placeholder="Nick Name"
                        />
                      </div>

                      {/* Email */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Email")}
                        </label>
                        <input
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          type="email"
                          name="email"
                          className="gomeet-input w-full"
                          placeholder="Email"
                        />
                      </div>

                      {/* Mobile Number */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Mobile Number")}
                        </label>
                        <div className="flex items-center gap-2 border border-gray-300 rounded-xl px-3.5 h-11 bg-gray-50/50 focus-within:border-purple-600 focus-within:ring-2 focus-within:ring-purple-100 transition-all">
                          <span className="text-xs font-bold text-gray-600 shrink-0 bg-gray-200/70 px-2 py-1 rounded-md">
                            {ccode || "+1"}
                          </span>
                          <input
                            value={number}
                            name="mobile"
                            onChange={(e) => setNummber(e.target.value)}
                            type="number"
                            className="w-full bg-transparent text-sm text-gray-900 outline-none"
                            placeholder="Mobile Number"
                          />
                        </div>
                      </div>

                      {/* Password */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Password")}
                        </label>
                        <div className="relative flex items-center border border-gray-300 rounded-xl px-3.5 h-11 bg-gray-50/50 focus-within:border-purple-600 focus-within:ring-2 focus-within:ring-purple-100 transition-all">
                          <FiLock className="text-gray-400 text-base shrink-0 mr-2.5" />
                          <input
                            id="input"
                            type="password"
                            className="w-full bg-transparent text-sm text-gray-900 outline-none pr-8"
                            placeholder="Password"
                            name="password"
                            value={Password}
                            onChange={(e) => setpassword(e.target.value)}
                          />
                          <button
                            type="button"
                            className="absolute right-3.5 text-gray-400 hover:text-purple-600 cursor-pointer"
                            onClick={() => myFunction()}
                          >
                            <img
                              ref={Show}
                              alt="Show"
                              src={ShowPassword}
                              className="w-5 h-5 hidden"
                            />
                            <img
                              ref={Hide}
                              alt="Hide"
                              src={HidePassword}
                              className="w-5 h-5"
                            />
                          </button>
                        </div>
                      </div>

                      {/* Birthdate */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Birthdate")}
                        </label>
                        <div className="profile-birthdate-field w-full h-11">
                          <div className="profile-birthdate-field__icon">
                            <MdDateRange />
                          </div>
                          <div className="profile-birthdate-field__content w-full">
                            <DatePicker
                              className="profile-birthdate-input w-full"
                              selected={selectedBirthDate}
                              onChange={(date) => setBirthDate(formatDateValue(date))}
                              placeholderText="Select birthdate"
                              minDate={minBirthDate}
                              maxDate={maxBirthDate}
                              dateFormat="dd-MM-yyyy"
                              showYearDropdown
                              showMonthDropdown
                              dropdownMode="select"
                              scrollableYearDropdown
                              yearDropdownItemNumber={Math.max(ageSettings.maxAge - ageSettings.minAge, 20)}
                              calendarClassName="gomeet-datepicker"
                              popperClassName="gomeet-datepicker-popper"
                              popperPlacement="bottom"
                              renderCustomHeader={({
                                date,
                                decreaseMonth,
                                increaseMonth,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                              }) => (
                                <div className="gomeet-datepicker__header">
                                  <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                    <MdChevronLeft />
                                  </button>
                                  <span>{date && !isNaN(date.getTime()) ? format(date, "MMMM yyyy") : ""}</span>
                                  <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                    <MdChevronRight />
                                  </button>
                                </div>
                              )}
                            />
                          </div>
                        </div>
                        <small className="text-[11px] text-gray-500 mt-1 block font-medium">
                          Allowed age: {ageSettings.minAge}-{ageSettings.maxAge} years
                          {selectedAge !== null ? ` | Age: ${selectedAge}` : ""}
                        </small>
                      </div>

                      {/* Height */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Height")}
                        </label>
                        <div className="flex items-center gap-2 border border-gray-300 rounded-xl px-3.5 h-11 bg-gray-50/50 focus-within:border-purple-600 focus-within:ring-2 focus-within:ring-purple-100 transition-all w-full">
                          <input
                            type="number"
                            className="w-full bg-transparent text-sm text-gray-900 outline-none"
                            placeholder="Height"
                            name="height"
                            value={height}
                            onChange={(e) => setHeight(e.target.value)}
                          />
                          <span className="text-xs font-bold text-gray-500 shrink-0">
                            {t("CM")}
                          </span>
                        </div>
                      </div>

                      {/* Gender */}
                      <div className="md:col-span-2">
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Gender")}
                        </label>
                        <div className="flex flex-wrap items-center gap-2">
                          {genderOptions.map((option) => (
                            <button
                              type="button"
                              key={option.value}
                              onClick={() => setGender(option.value)}
                              className={`gomeet-pill ${gender === option.value ? "active" : ""}`}
                            >
                              {option.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Bio */}
                      <div className="md:col-span-2">
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Bio")}
                        </label>
                        <input
                          ref={bioRef}
                          value={bio === "undefined" ? "" : bio}
                          onChange={(e) => setBio(e.target.value)}
                          type="text"
                          name="bio"
                          className={`gomeet-input w-full ${
                            location.state?.profileCompletionRequired ? "border-purple-600 ring-2 ring-purple-100" : ""
                          }`}
                          placeholder="Tell us a bit about yourself..."
                        />
                      </div>
                    </div>
                  </div>

                  {/* Section 3: Preferences & Location */}
                  <div>
                    <div className="flex items-center justify-between mb-4 pb-2 border-b border-gray-100">
                      <h3 className="text-sm sm:text-base font-bold text-gray-900 flex items-center gap-2 m-0">
                        <FiMapPin className="text-purple-600 text-base" />
                        {t("Preferences & Location")}
                      </h3>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                      {/* Distance Preference */}
                      <div>
                        <div className="flex items-center justify-between mb-1.5">
                          <label className="text-xs font-semibold text-gray-700">
                            {t("Distance Preference")}
                          </label>
                          <span className="text-xs font-bold text-purple-700">
                            {Number(distance).toFixed(2)} {distanceSettings.distanceUnit.toLowerCase()}
                          </span>
                        </div>
                        <input
                          style={sliderStyle}
                          type="range"
                          className="Range w-full cursor-pointer"
                          min={distanceSettings.minDistance}
                          name="radius_search"
                          max={distanceSettings.maxDistance}
                          step="1"
                          value={distance}
                          onChange={(e) => setDistance(Number(e.target.value))}
                        />
                        <div className="flex justify-between text-[11px] text-gray-400 mt-1">
                          <span>{distanceSettings.minDistance} {distanceSettings.distanceUnit.toLowerCase()}</span>
                          <span>{distanceSettings.maxDistance} {distanceSettings.distanceUnit.toLowerCase()}</span>
                        </div>
                      </div>

                      {/* Search Preference */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Search Preference")}
                        </label>
                        <div className="flex flex-wrap items-center gap-2">
                          {searchPreferenceOptions.map((option) => (
                            <button
                              type="button"
                              key={option.value}
                              onClick={() => setPreference(option.value)}
                              className={`gomeet-pill ${preference === option.value ? "active" : ""}`}
                            >
                              {option.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Location Card */}
                      <div ref={locationRef} className="md:col-span-2">
                        <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                          {t("Location")}
                        </label>
                        <div
                          className={`rounded-xl p-3.5 sm:p-4 border ${
                            isLocationMissing ? "border-purple-300 bg-purple-50/50" : "border-gray-200 bg-gray-50/50"
                          } transition-all`}
                        >
                          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                            <div className="flex items-center gap-3 min-w-0 flex-1">
                              <div className="w-9 h-9 rounded-xl bg-purple-100 text-purple-700 flex items-center justify-center text-lg shrink-0">
                                <MdMyLocation />
                              </div>
                              <div className="min-w-0 flex-1">
                                <div className="flex items-center gap-2 flex-wrap">
                                  <span className="text-xs font-bold text-gray-900">
                                    {latitude && longitude ? t("Current location captured") : t("Location not added")}
                                  </span>
                                  {latitude && longitude && (
                                    <span className="text-[11px] text-gray-500 font-medium">
                                      ({t("Lat")}: {latitude}, {t("Lon")}: {longitude})
                                    </span>
                                  )}
                                </div>
                                <p className="m-0 text-xs text-gray-500 truncate mt-0.5">
                                  {locationAddress || locationStatus || t("Use your current location for matching and distance.")}
                                </p>
                              </div>
                            </div>
                            <button
                              type="button"
                              onClick={requestCurrentLocation}
                              className="px-4 py-2 rounded-xl bg-purple-600 hover:bg-purple-700 text-white text-xs font-semibold shadow-xs transition-all shrink-0 flex items-center gap-1.5 cursor-pointer active:scale-95 self-stretch sm:self-auto justify-center"
                            >
                              <MdMyLocation className="text-xs" />
                              <span>{t("Use Current Location")}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Section 4: Interests & Languages */}
                  <div>
                    <div className="flex items-center justify-between mb-4 pb-2 border-b border-gray-100">
                      <h3 className="text-sm sm:text-base font-bold text-gray-900 flex items-center gap-2 m-0">
                        <FiHeart className="text-purple-600 text-base" />
                        {t("Interests & Languages")}
                      </h3>
                    </div>

                    <div className="space-y-5">
                      {/* Interests */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-2">
                          {t("Interests")}
                        </label>
                        <div className="flex flex-wrap gap-2">
                          {interestList.map((el) => {
                            const isSelected = interest.some(
                              (i) =>
                                String(i).trim().toLowerCase() === String(el.id || "").trim().toLowerCase() ||
                                String(i).trim().toLowerCase() === String(el.title || "").trim().toLowerCase()
                            );
                            return (
                              <button
                                key={el.id}
                                type="button"
                                onClick={() => InterestMapHandler(el.id)}
                                className={`gomeet-pill inline-flex items-center justify-center gap-1.5 ${isSelected ? "active" : ""}`}
                              >
                                <span>{el.title}</span>
                                {el.img && (
                                  <img
                                    src={imageBaseURL + el.img}
                                    alt=""
                                    className="w-4 h-4 object-contain shrink-0"
                                  />
                                )}
                              </button>
                            );
                          })}
                        </div>
                      </div>

                      {/* Languages */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-2">
                          {t("Langusges I Know")}
                        </label>
                        <div className="flex flex-wrap gap-2">
                          {languageList.map((el) => {
                            const isSelected = language.some(
                              (l) =>
                                String(l).trim().toLowerCase() === String(el.id || "").trim().toLowerCase() ||
                                String(l).trim().toLowerCase() === String(el.title || "").trim().toLowerCase()
                            );
                            return (
                              <button
                                key={el.id}
                                type="button"
                                onClick={() => LanguageMapHandler(el.id)}
                                className={`gomeet-pill ${isSelected ? "active" : ""}`}
                              >
                                {el.title}
                              </button>
                            );
                          })}
                        </div>
                      </div>

                      {/* Religion */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-2">
                          {t("Religion")}
                        </label>
                        <div className="flex flex-wrap gap-2">
                          {religionList.map((el) => {
                            const isSelected = String(religion || "") === String(el.id || "") ||
                              String(religion || "").trim().toLowerCase() === String(el.title || "").trim().toLowerCase();
                            return (
                              <button
                                key={el.id}
                                type="button"
                                onClick={() => setReligion(el.id)}
                                className={`gomeet-pill ${isSelected ? "active" : ""}`}
                              >
                                {el.title}
                              </button>
                            );
                          })}
                        </div>
                      </div>

                      {/* Relationship Goals */}
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-2">
                          {t("Relationship Goals")}
                        </label>
                        <div className="flex flex-wrap gap-2">
                          {relationshipList.map((el) => {
                            const isSelected = String(relationship || "") === String(el.id || "") ||
                              String(relationship || "").trim().toLowerCase() === String(el.title || "").trim().toLowerCase();
                            return (
                              <button
                                key={el.id}
                                type="button"
                                onClick={() => setRelationship(el.id)}
                                className={`gomeet-pill ${isSelected ? "active" : ""}`}
                              >
                                {el.title}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="pt-6 border-t border-gray-100 flex items-center justify-start">
                    <button
                      type="submit"
                      className="px-8 py-2.5 rounded-xl bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-bold text-xs sm:text-sm shadow-md hover:shadow-lg transition-all transform active:scale-95 cursor-pointer tracking-wide shrink-0"
                    >
                      {t("Update Profile")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
    </Formik>
  );
};

export default Profile;
/* jshint ignore:end */
